import axios from 'axios'
import AWS from 'aws-sdk'
import md5 from 'js-md5'

var oss = {}
var s3 = null
const Token = 'IqBfMawdecJEib54EWZcud'

let baseURL = 'http://192.168.31.81:4000/'

if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://api-v2.n2yun.net/'
}


function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(`${name}=`)) {
            return cookie.substring(name.length + 1);
        }
    }
    return null;
}


//  获取本地的token
function getToken() {
    return getCookie('n2yunToken')
}

//  获取上传批准
// function Execute_Oss(data, ck) {

//     const ctime = Date.now()
//     // const sign = md5('/api/v2/Generate_Token' + ctime + Token)

//     data.token = getToken()

//     let config_data = JSON.stringify(data)
//     const sign = md5('/api/v2/Generate_Token' + config_data + ctime + Token)

//     axios.request({
//         url: `/api/v2/Generate_Token?sign=${sign}&signctime=${ctime}`,
//         method: 'post',
//         baseURL: baseURL,
//         data: data,
//     }).then(
//         res => {
//             if (res.data.code === 200) {
//                 let msgs = res.data.data.data.oss_token
//                 s3 = new AWS.S3({
//                     region: 'automatic',
//                     endpoint: msgs.s3Endpoint,
//                     credentials: msgs.credentials,
//                     params: {
//                         Bucket: msgs.s3Bucket
//                     }
//                 })
//                 ck(s3, msgs.file_name)
//             } else {
//                 return
//             }
//         }, error => {
//             return
//         }
//     )
// }

//  获取上传批准
function Execute_Oss_rainyun(data, ck) {
    const ctime = Date.now()
    // const sign = md5('/api/v2/Get_Upload_Url' + ctime + Token)

    data.token = getToken()
    let config_data = JSON.stringify(data)
    const sign = md5('/api/v2/Get_Upload_Url' + config_data + ctime + Token)

    axios.request({
        url: `/api/v2/Get_Upload_Url?sign=${sign}&signctime=${ctime}`,
        method: 'post',
        baseURL: baseURL,
        data: data,
    }).then(
        res => {
            // if (res.data.code === 200) {
            //     let msgs = res.data.data.data
            //     ck(msgs)
            // } else {
            //     ck( res.data)
            //     return false
            // }

            ck(res.data)
        }, error => {
            return false
        }
    )
}

//  上传处理
oss.upload = (data, ck) => {
    if (data.ros) {
        let name = data.name
        if (data.type === 'imgs') {
            name = Date.now() + '_' + name
        }
        if (data.type === 'file') {
            name = Date.now() + '_' + name
        }

        Execute_Oss_rainyun({
            name: name,
            type: data.type,
            size: data.size,
            ros: true,
        }, async (msgs) => {
            // var params = {
            //     Body: data.file,
            //     Key: file_name,
            // }

            if (msgs.code === 200) {
                // 2. 直传 MinIO
                const uploadResponse = await axios.put(
                    msgs.data.data.url_token,
                    data.file,
                    {
                        headers: {
                            'Content-Type': data.file.type || 'application/octet-stream',
                            // 'x-amz-acl': 'private', // 明确设置存储权限
                        },
                    }
                );

                if (uploadResponse.status === 200) {
                    ck({
                        url: `https://${msgs.data.data.tname}.${msgs.data.data.endPoint}/` + msgs.data.data.file_name
                    })
                }
                return
            }

            ck({
                text: msgs.data.text
            })
            // if (msgs) {
            //     ck({
            //         url: msgs
            //     })
            // }
        })

        return
    }



    if (data.rainyun) {
        let name = data.name
        if (data.type === 'imgs') {
            name = Date.now() + '_' + name
        }
        if (data.type === 'file') {
            name = Date.now() + '_' + name
        }

        Execute_Oss_rainyun({
            name: name,
            type: data.type,
            size: data.size,
            nzadmin: data.nzadmin,
        }, async (msgs) => {
            // var params = {
            //     Body: data.file,
            //     Key: file_name,
            // }


            // 2. 直传 MinIO
            const uploadResponse = await axios.put(
                msgs.data.data.url_token,
                data.file,
                {
                    headers: {
                        'Content-Type': data.file.type || 'application/octet-stream',
                        'x-amz-acl': 'private', // 明确设置存储权限
                    },
                }
            );

            if (uploadResponse.status === 200) {
                if (data.nzadmin) {
                    ck({
                        url: `/` + msgs.data.data.file_name
                    })
                    return
                }

                ck({
                    url: 'https://cdn-r.n2yun.com.cn/' + msgs.data.data.file_name
                })
            }
        })

        return
    }




    //  2026-03-14 弃用此方法
    // let name = data.name
    // if (data.type === 'imgs') {
    //     name = Date.now() + '_' + name
    // }

    // Execute_Oss({
    //     name: name,
    //     type: data.type,
    //     size: data.size,
    // }, (s3, file_name) => {
    //     var params = {
    //         Body: data.file,
    //         Key: file_name,
    //     }
    //     s3.putObject(params, function (err, msg) {
    //         if (err) {
    //             console.log(err);
    //             return
    //         } else {
    //             console.log(msg);
    //             ck({
    //                 url: 'https://cdn.n2yun.com.cn/' + file_name
    //             })
    //         }
    //     })
    // })
}

export default oss;